import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { configs, convertToUppercase, translate, showMessageToastCustom, getPreAllocationArea } from '../../../../utils/util';
import { withTranslation } from 'react-i18next';
import PhysicalConfirmationService from '../../../../services/PhysicalConfirmationService';
import { ENUMS, VISIONS } from '../../../../utils/constants';
import { onValueChange, validateInputsRequired } from "../../../../utils/handleChangeHooks";
import { Input, Button, BackButton, Title, Subtitle } from '../../../../components/UI/ComponentsUI';
import { getVision } from '../../../../services/auth';
import ConfirmModalUI from '../../../../components/UI/ConfirmModalUI';
import useStateWithPromise from '../../../../utils/useEffectUpdate';

const AutomaticLowConfirm = (props) => {
    const goBack = props.location?.state?.goBack;
    const [config, setConfig] = useState({});
    const [confirmation, setConfirmation] = useState({});
    const [openModal, setOpenModal] = useState(false);
    const [messagesConfirmation, setMessagesConfirmation] = useStateWithPromise([]);

    useEffect(() => {
        setConfig(configs(ENUMS.eModules.PhysicalConfirmation.value, props.config?.items));
        var vision = getVision();
        var confirmationProps = props.confirmation;
        confirmationProps.boxQuantity = 1;
        confirmationProps.boxQuantityItems = props.confirmation.balance;
        confirmationProps.printLabel = false;
        confirmationProps.place = "1";
        confirmationProps.print = "L";
        confirmationProps.preAllocationArea = getPreAllocationArea(vision);
        setConfirmation({ ...confirmationProps });
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (getVision() === VISIONS.Faasa || getVision() === VISIONS.FaasaCKD) {
            props.setPrintSelect(ENUMS.ePrintTypes.Click.value);
        }

        // eslint-disable-next-line
    }, []);

    const handleFormKeyDown = (e) => {
        if (e.key === 'Enter') {
            submit();
        }
    }

    const onChange = (event) => {
        onValueChange(event, confirmation, setConfirmation);
    };

    const isValid = () => {
        let result = true;
        if (!props.user.vision || props.user.vision === '') {
            showMessageToastCustom({ html: translate('select-vision', 'validations'), classes: 'red' });
            result = false;
        }

        if ((!props.user.shed || props.user.shed === '') && Boolean(config.shedRequiredPhysicalConfirmation)) {
            showMessageToastCustom({ html: translate('select-shed', 'validations'), classes: 'red' });
            result = false;
        }

        if ((!props.user.dock || props.user.dock === '') && Boolean(config.dockRequiredPhysicalConfirmation)) {
            showMessageToastCustom({ html: translate('select-dock', 'validations'), classes: 'red' });
            result = false;
        }

        if (config.mdrRequired && (confirmation.mdr === '' || !confirmation.mdr)) {
            showMessageToastCustom({ html: translate('mdr-not-informed', 'physical-confirmation'), classes: 'red' });
            result = false;
        }

        return result;
    }

    const submit = () => {
        if (isValid() && validateInputsRequired("formConfirmationItemModal")) {
            var dockRequired = Boolean(config.shedRequiredPhysicalConfirmation);
            var shedRequired = Boolean(config.dockRequiredPhysicalConfirmation);
            confirmation.dock = !dockRequired ? "M01" : props.user.dock;
            confirmation.shed = !shedRequired ? "" : props.sheds.find((i) => i.id === props.user.shed)?.code;
            confirmation.preAllocation = "S"
            confirmation.print = "L";
            confirmation.preAllocationArea = "%"
            confirmation.mvi = props.filter?.mvi;
            confirmation.truckKanban = props.filter?.truckKanban;

            props.sendAutomaticLow(confirmation, (messages) => {
                if (messages.length > 0) {
                    setMessagesConfirmation(messages).then(() => {
                        setOpenModal(true);
                    });
                } else {
                    leave();
                }
            });
        }
    }

    const leave = () => {
        if (goBack) {
            props.history.goBack();
        } else {
            props.setActiveTab(0);
            props.history.push({ pathname: '../V2/receiptStorages', ...props });
        }
    }

    const validadeRemainingBalance = () => {
        var remainingQuantity = props.confirmation.balance;
        var qtd = confirmation.boxQuantity * confirmation.boxQuantityItems;
        if (qtd > 0) {
            remainingQuantity = remainingQuantity - qtd;
        }
        return remainingQuantity;
    }

    return (
        <div>
            <BackButton {...props} onClick={() => leave()} />
            <div className="container-fluid h-65">
                <div className="row">
                    <Title icon="mdi mdi-clipboard-check" label={translate("physical-confirmation:phisicalconfirmation")} />
                    <Subtitle icon="mdi mdi-layers" label={confirmation.partNumberCode} />
                </div>
            </div>
            <div className="container-fluid" style={{ marginTop: '25px', }}>
                <div className="container" style={{ width: '96%' }}>
                    <div className="card">
                        <div className="card-content" style={{ padding: '3px', paddingBlockEnd: '1px' }}>
                            <div>
                                <div className="col s12">
                                    <span className="field sixth-text-color f-1p5r" style={{ marginBottom: 0 }}>{confirmation.partNumberCode}</span>
                                    <span className="field sixth-text-color f-1p5r" style={{ marginBottom: 0, marginLeft: 50 }}>{translate('physical-confirmation:almox')}: {confirmation.almox}</span>
                                </div>
                                <div className="col s12">
                                    <span className="field f-1r sixth-text-color" style={{ marginBottom: 0 }}>{confirmation.partNumberDescription}</span>
                                </div>
                                <div className="row">
                                    <div className="input-field no-padding col s3">
                                        <span className="field f-1r" style={{ marginBottom: 0 }}>{props.confirmation.balance}</span>
                                        <label className="active" htmlFor="lot"> {translate('general:available')}</label>
                                    </div>
                                    <div className="input-field no-padding col s3">
                                        <span className="field f-1r" style={{ marginBottom: 0 }}>{props.confirmation.qme || ''}</span>
                                        <label className="active" htmlFor="qme">{translate('physical-confirmation:qme')}</label>
                                    </div>
                                    <div className="input-field no-padding col s4">
                                        <span className="field f-1r" style={{ marginBottom: 0 }}>{props.confirmation.mdr || ''}</span>
                                        <label className="active" htmlFor="qme">{translate('physical-confirmation:mdr-origin')}</label>
                                    </div>
                                </div>
                                <form onKeyDown={handleFormKeyDown} id="formConfirmationItemModal">
                                    <div className="row">
                                        <div className="input-field no-padding col s6">
                                            <Input
                                                id="boxQuantity"
                                                name="boxQuantity"
                                                className="required"
                                                required
                                                aria-required="true"
                                                type="number"
                                                defaultValue={confirmation.boxQuantity}
                                                onChange={onChange}
                                                onBlur={onChange}
                                                min={1}
                                                maxLength="6"
                                                step="1"
                                                label={translate('volume', 'physical-confirmation')}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s5">
                                            <Input
                                                id="mdr"
                                                name="mdr"
                                                type="text"
                                                required
                                                defaultValue={confirmation.mdr || ''}
                                                onChange={(e) => {
                                                    convertToUppercase(e);
                                                    onChange(e)
                                                }}
                                                maxLength="5"
                                                label={translate('physical-confirmation:mdr')}
                                            />
                                        </div>
                                        <div className="input-field no-padding col s12">
                                            <Input
                                                id="boxQuantityItems"
                                                name="boxQuantityItems"
                                                className="required"
                                                required
                                                aria-required="true"
                                                type="number"
                                                defaultValue={confirmation.boxQuantityItems}
                                                onChange={onChange}
                                                onBlur={onChange}
                                                min={1}
                                                maxLength="10"
                                                label={translate('partnumber', 'physical-confirmation')}
                                            />
                                        </div>
                                        <div className="col s12" style={{ padding: '0px', color: 'red', paddingTop: '5px', paddingBottom: '5px' }}>
                                            <label className="field f-1p5r truncate col s12" style={{ color: 'red' }} htmlFor="remainingQuantity">{translate('physical-confirmation:remainingQuantity')}: {validadeRemainingBalance()}</label>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className="row">
                                <Button onClick={leave} text={translate('cancel', 'general')} secundary="true" />
                                <Button onClick={submit} text={translate('confirm', 'general')} />
                            </div>
                        </div>
                    </div>
                </div>
            </div >
            <ConfirmModalUI
                open={openModal}
                id="messageModalLow"

                data={{
                    title: translate('validations:attention'),
                    message: <h5 className='row' style={{ color: 'green' }}>Armazenamento gerado com sucesso!</h5>,
                    children: <div className='row'>
                        {
                            messagesConfirmation.map((item, index) => (
                                <div key={index} className="input-field no-padding col s12" style={{ color: item.success ? 'green' : 'red' }}>
                                    {item.message}
                                </div>
                            ))}
                    </div>
                }}
                onConfirm={() => {
                    setOpenModal(false)
                }}
                onClose={() => {
                    setOpenModal(false);
                    leave()
                }}
                btnConfirm={translate('confirm', 'general')}
            />
        </div>
    );
}



const mapStateToProps = (state) => {
    return {
        confirmation: state.physicalConfirmationReducer.confirmation,
        user: state.userReducer.user,
        config: state.configReducer.config,
        sheds: state.configReducer.sheds,
        receipt: state.physicalConfirmationReducer.receipt,
        areas: state.areaReducer.areas,
        resources: state.logisticsResourceReducer.list,
        printSelect: state.physicalConfirmationReducer.printSelect,
        filter: state.physicalConfirmationReducer.filter
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateDate: (partnumber, value, key) => {
            dispatch(PhysicalConfirmationService.updateDate(partnumber, value, key));
        },
        sendAutomaticLow: (item, callback) => {
            dispatch(PhysicalConfirmationService.sendAutomaticLow(item, callback));
        },
        setActiveTab: (tabIndex) => {
            dispatch(PhysicalConfirmationService.setActiveTab(tabIndex));
        }
    };
};


export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AutomaticLowConfirm));
